import { TeamDetails } from '@tokenbox/domain';
import { DialogService } from 'primeng/dynamicdialog';
import { PermissionDeniedDialog } from './permission-denied.dialog';
import { firstValueFrom } from 'rxjs';

export const showPermissionDeniedDialog =
  (dialogService: DialogService) =>
  async (team: TeamDetails, text: string, title?: string) => {
    const ref = dialogService.open(
      ...PermissionDeniedDialog(team, text, title),
    );
    if (ref) {
      await firstValueFrom(ref.onClose);
    }
  };
